<template>
  <div class="LoginWrap">
    <div class="LogoBox">
      <img src="@/assets/Flybit_Logo_color_column.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  created() {
    location.href = "https://applink.flybit.com/appLogin";
  },
};
</script>
<style lang="scss" scoped>
.LoginWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  .LogoBox {
    width: 100px;
    img {
      width: 100%;
    }
  }
}
</style>
